import type React from 'react'

interface EyeOpenIconProps {
  size?: number | string
  color?: string
  className?: string
}

const EyeOpenIcon: React.FC<EyeOpenIconProps> = ({ size = 24, color = 'currentColor', className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={'Eye Open Icon'}
      role="img"
    >
      <path
        d="M14.8302 12C14.8302 10.4343 13.5659 9.17001 12.0002 9.16997C10.4344 9.16997 9.17009 10.4343 9.17009 12C9.17013 13.5658 10.4344 14.8301 12.0002 14.8301C13.5659 14.8301 14.8302 13.5658 14.8302 12ZM16.3302 12C16.3302 14.3942 14.3943 16.3301 12.0002 16.3301C9.60598 16.3301 7.67013 14.3942 7.67009 12C7.67009 9.60583 9.60595 7.66997 12.0002 7.66997C14.3943 7.67001 16.3302 9.60586 16.3302 12Z"
        fill={color}
      />
      <path
        d="M12.0002 2.96997C15.8478 2.97003 19.3506 5.23859 21.7415 8.99634C22.2869 9.85082 22.5354 10.9461 22.5354 11.9954C22.5353 13.0444 22.2877 14.1391 21.7424 14.9934L21.7415 14.9924C19.3506 18.7507 15.8481 21.0197 12.0002 21.0198C8.1521 21.0198 4.648 18.7511 2.25708 14.9924C1.71254 14.1383 1.46515 13.0437 1.46509 11.9954C1.46509 10.9461 1.71264 9.85082 2.25806 8.99634C4.64896 5.23836 8.15248 2.96997 12.0002 2.96997ZM12.0002 4.46997C8.78839 4.46997 5.71178 6.36164 3.52271 9.80298C3.16817 10.3585 2.96509 11.1547 2.96509 11.9954C2.96514 12.7308 3.12049 13.4313 3.39673 13.967L3.52271 14.1868C5.71178 17.628 8.78843 19.5198 12.0002 19.5198C15.2119 19.5197 18.2878 17.6288 20.4768 14.1877L20.4778 14.1868C20.8323 13.6313 21.0353 12.836 21.0354 11.9954C21.0354 11.1547 20.8323 10.3595 20.4778 9.80396L20.4768 9.80298C18.2878 6.36169 15.212 4.47003 12.0002 4.46997Z"
        fill={color}
      />
    </svg>
  )
}

export default EyeOpenIcon
